import { render } from "./DefaultModalTitle.vue?vue&type=template&id=83fd8a68&scoped=true"
import script from "./DefaultModalTitle.vue?vue&type=script&lang=js"
export * from "./DefaultModalTitle.vue?vue&type=script&lang=js"

import "./DefaultModalTitle.vue?vue&type=style&index=0&id=83fd8a68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83fd8a68"],['__file',"src/components/DefaultModalTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "83fd8a68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('83fd8a68', __exports__)) {
    api.reload('83fd8a68', __exports__)
  }
  
  module.hot.accept("./DefaultModalTitle.vue?vue&type=template&id=83fd8a68&scoped=true", () => {
    api.rerender('83fd8a68', render)
  })

}


export default __exports__